import ApiService from '@jobstairs/axios-api-service';
import tokenService from '@/services/TokenService';

export default class AiWriterService {
    #config;
    #apiService;

    constructor(config) {
        this.#config = config;
        this.#apiService = new ApiService({ baseURL: this.#config.baseURL });
    }
    async optimizeText(fulltext, title = '') {
        const headers = tokenService.getAuthenticationHeader()['headers'];
        const { data } = await this.#apiService.post({
            endpoint: this.#config.endpoint,
            data: { title, fulltext, getHTML: true },
            headers,
        });
        return data;
    }
}
